module.exports = __webpack_public_path__ + "img/signup-footer-bg.927af93b.webp";